import configs from "@/i18n/configs"
export default {
    home: 'الصفحة الرئيسية',
    'medRepZone': `${configs.medRepZone.ar}`,
    visits: 'الزيارات',
    'med-rep-plan':`${configs.medRepPlan.ar}`,
    'day-off-requests': 'طلبات الإجازة',
    'day-off-request': 'طلب إجازة',
    reports: 'تقارير',
    'med-rep-mark': `${configs.medRepMark.ar}`,
    exams: 'اختبارات',
    salaries: 'الرواتب',
    inventory: 'الجرد',
    'delivery-samples': 'تسليم مواد',
    'create-samples': 'إنشاء مواد',
    statement: 'كشف',
    'products-statement': 'كشف مواد',
    management: 'إدارة',
    staff: 'طاقم العمل',
    customers: 'الزبائن',
    'managing-roles': 'إدارة الأدوار',
    'external-entities': 'الجهات الخارجية',
    products: 'المواد',
    'regions-management': 'إدارة المناطق',
    'administrative-zone': 'القسم الإداري',
    'my-visits': 'زياراتي',
    'report': 'التقرير',
    'plan': 'الخطة',
    logout: 'تسجيل الخروج',

    'add-day-off-request': 'إضافة طلب إجازة',
    "minimal-interface": "مواد على وشك النفاذ",
    "warehouses-statistics": "إحصائيات المستودع",
    "daily-report": "الملاحظات اليومية",
    'prices-types': 'أنواع الأسعار',
    'employee-stock': 'مخزون الموظفين',
    'vacations': 'العطل',
    'specialty-and-teams': 'خطة العينات بالنسبة للفرق',
    'customers-types': 'أنواع الزبائن',
    'administrative-visit': 'زيارات إداري'
}